const STORAGE_KEY = 'hv_avatar_url';

/** Same initials for header + sidebar (e.g. "Deepika Jangid" → "DJ"). */
export function getNameInitials(name, fallback = 'U') {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return fallback;
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase() || fallback;
  }
  return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase() || fallback;
}

export function isUsablePhotoUrl(value) {
  const s = String(value || '').trim();
  if (!s || s === 'undefined' || s === 'null') return false;
  if (s.includes('default_avatar')) return false;
  return true;
}

/**
 * One ordered list for header + sidebar.
 * Prefer the candidate `dp`, then the auth/session photo.
 */
export function resolveProfilePhotoUrls({ dp, userImage } = {}) {
  const seen = new Set();
  const out = [];
  for (const raw of [dp, userImage]) {
    if (!isUsablePhotoUrl(raw)) continue;
    const key = String(raw).trim().split('?')[0];
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(String(raw).trim());
  }
  return out;
}

export function getStoredAvatarUrl() {
  try {
    const v = sessionStorage.getItem(STORAGE_KEY);
    return isUsablePhotoUrl(v) ? v : '';
  } catch {
    return '';
  }
}

export function storeAvatarUrl(url) {
  if (!isUsablePhotoUrl(url)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, String(url).trim());
  } catch {
    /* ignore quota / private mode */
  }
}

export function rememberAvatarFromSources(sources) {
  const urls = resolveProfilePhotoUrls(sources);
  if (urls[0]) storeAvatarUrl(urls[0]);
  return urls;
}
